import { AWARDS_RECEIVED } from '../../actions/product-management/GetAwardsForProduct';

const initialState = {
  productId: null,
  awards: [],
};

const awards = (state = initialState, action) => {
  switch (action.type) {
    case AWARDS_RECEIVED:
      return {
        productId: action.productId,
        awards: action.awards,
      };
  }

  return state;
};

export default awards;
